import {DataStorage, IEventManagerWithAsync} from '@gongxigames/framework/core';
import {AbstractFilter} from '@gongxigames/framework/slot/services/logic';

export interface IModuleContext<Data> {
    storage: DataStorage<Data>;
}

export type CheatAction = {
    id: string;
    apply: () => void;
    reject: () => void;
};

export type DataProps = {
    statsEnabled: boolean;
    rewindVisible: boolean;
    cheatsInfoEnabled: boolean;
    replayLastSpinEnabled: boolean;
    reelsAmount: number;
    rowsAmount: number;
    resourceLoaded: boolean;
    cheatActions: CheatAction[];
    visibleView: boolean;
};

export interface ICheatsModuleContext extends IModuleContext<DataProps> {
    removeCheatAction: (action: CheatAction) => void;
}

export interface ICheatsModule {
    addCheatAction: (action: CheatAction) => void;
    removeCheatAction: (action: CheatAction) => void;
    addArrayFilter: (filter: AbstractFilter) => void;
    removeArrayFilter: (filter: AbstractFilter) => void;
    storage: DataStorage<DataProps>;
    eventManager: IEventManagerWithAsync;
}

export type CheatPlugin = {
    name: string;
    init: () => [
        new () => ICheatPluginController,
        new (arg: any) => any
    ];
};

export interface ICheatPluginController {
    init: (module: ICheatsModule) => void;
}

export interface ICheatPluginView<CheatPluginController = {}> {
    controller: CheatPluginController;
}

export type CheatPluginObject = {
    view: new (arg: any) => any;
    controller: ICheatPluginController;
    name: string;
};

export type CheatPluginsObjects = Record<string, CheatPluginObject>;
export type CheatPlugins = Record<string, CheatPlugin>;
